var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { AlertBanner, AlertBannerTypes } from '../Components/AlertBanner';
import { AutosaveCheckbox } from '../Components/AutosaveForm/AutosaveCheckbox';
import { useAutosaveForm } from '../Components/AutosaveForm/AutosaveForm';
import { AutosaveTextField } from '../Components/AutosaveForm/AutosaveTextField';
import { MaskedTextField } from '../Components/MaskedTextField';
import { PaymentSchemeType, PbsRestrictionType } from '../Contracts/MedicationModels';
import { requiredField } from '../Medications.en';
import { doesPaymentSchemeNeedApprovalNumber } from './MedicationPaymentDetails';
import styles from './PaymentAuthorityDetails.module.css';
import { useMedicationSettings } from '../Config/MedicationConfig';
import { uppercaseStringInputFilter } from '../Shared/InputFilters';
export var paymentAuthoritySectionElementId = 'paymentAuthoritySection';
export var PaymentAuthorityDetails = function (props) {
    var form = useAutosaveForm().form;
    var approvalNumber = form.formValues.paymentDetailApprovalNumber;
    var _a = __read(useState(form.dirty.paymentDetailApprovalNumber), 2), approvalNumberDirty = _a[0], setApprovalNumberDirty = _a[1];
    var medicationSettings = useMedicationSettings();
    var authorityNumberTerm = medicationSettings.settings.authorityNumberTerm;
    var approvalNumberTerm = medicationSettings.settings.approvalNumberTerm;
    // Because the auto save form resets dirty status on successful save of a field, we need to make sure the status is remembered
    useEffect(function () {
        if (form.dirty.paymentDetailApprovalNumber)
            setApprovalNumberDirty(true);
    }, [form.dirty.paymentDetailApprovalNumber]);
    if (!props.restrictionType || props.schemeType === PaymentSchemeType.Private)
        return null;
    if ((props.restrictionType === PbsRestrictionType.Restricted ||
        props.restrictionType === PbsRestrictionType.Unrestricted) &&
        !props.needApprovalNumber)
        return null;
    var formSnapshot = form.formValues.snapshot;
    var showErrors = false;
    if (formSnapshot) {
        var itDoes = doesPaymentSchemeNeedApprovalNumber(formSnapshot.restrictionType, isNaN(Number(form.formValues.numberOfPacks)) ? 0 : Number(form.formValues.numberOfPacks), formSnapshot.maxNumberOfPacks, isNaN(Number(form.formValues.repeats)) ? 0 : Number(form.formValues.repeats), formSnapshot.maxNumberOfRepeats);
        showErrors = itDoes ? !approvalNumber : false;
    }
    return (React.createElement(React.Fragment, null,
        !props.readOnly && (React.createElement(React.Fragment, null, props.restrictionType === PbsRestrictionType.AuthorityRequired || props.needApprovalNumber ? (React.createElement(AlertBanner, { roundIcon: true, lowerHeight: true, promptType: AlertBannerTypes.Error, verticalSpace: true, infoLine: 'Authority required. Please call PBS: 1800 888 333 OR DVA: 1800 552 580.' })) : props.restrictionType === PbsRestrictionType.AuthorityRequiredStreamlined &&
            !props.needApprovalNumber ? (React.createElement(AlertBanner, { roundIcon: true, promptType: AlertBannerTypes.Error, infoLine: 'Streamlined Authority required. Select the approved indication that applies to your patient. If you need to prescribe more than the maximum number of PBS packs or repeats, call PBS: 1800 888 333 OR DVA: 1800 552 580.' })) : null)),
        React.createElement("div", { id: paymentAuthoritySectionElementId, className: styles.container },
            React.createElement(AutosaveTextField, { field: 'paymentDetailAuthorityNumber', label: authorityNumberTerm === null || authorityNumberTerm === void 0 ? void 0 : authorityNumberTerm.singularTerm, readOnly: true }),
            React.createElement("div", null),
            React.createElement(MaskedTextField, { value: props.prescriberNumber, readOnly: true, testId: 'prescriber-number', label: 'Prescriber number' }),
            React.createElement("div", null),
            React.createElement(AutosaveTextField, { field: 'paymentDetailApprovalNumber', filterFunction: uppercaseStringInputFilter, required: props.needApprovalNumber, readOnly: props.readOnly || !props.needApprovalNumber, label: approvalNumberTerm === null || approvalNumberTerm === void 0 ? void 0 : approvalNumberTerm.singularTerm, error: showErrors && approvalNumberDirty ? requiredField : '' }),
            React.createElement("div", null),
            React.createElement(AutosaveCheckbox, { field: 'paymentDetailReturnToPatient', label: 'Return to patient', readOnly: props.readOnly, labelStyles: { fontWeight: 400, fontSize: '16px' } }),
            React.createElement(AutosaveCheckbox, { field: 'paymentDetailPreviousAuthority', label: 'Previous authority', readOnly: props.readOnly, labelStyles: { fontWeight: 400, fontSize: '16px' } }))));
};
